import * as React from 'react';
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, OutlinedInput, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTags } from '../slices/tagsSlice';
import { fetchItems, resetStatus, setTag } from "../slices/itemsSlice2";
import { useEffect, useState } from 'react';
import { TagIcon } from './TagIcon';
import AddLinkIcon from '@mui/icons-material/AddLink';
import RightIcon from '@mui/icons-material/ChevronRight';
import ClearIcon from '@mui/icons-material/Cancel';
import RemoveLinkIcon from '@mui/icons-material/DeleteOutline';
import EditLinkIcon from '@mui/icons-material/Edit';
import { MyListApi } from '../utils/restApi';

/**
 * value - the item id
 *
 * @param {} param0
 * @returns
 */
export const LinkDialog = React.forwardRef(({ label, tagId, onChange = () => {} }, ref) => {

    const user = useSelector(state => state.login.user);
    const dispatch = useDispatch();
    const { tags, status, error } = useSelector(state => state.tags);
    const [ open, setOpen ] = useState(false);
    const [ selectedItem, setSelectedItem ] = useState();
    const [ searchValue, setSearchValue ] = useState('');
    const [ items, setItems ] = useState([]);
    const [ index, setIndex ] = useState(null);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchTags());
        }
    }, [status, dispatch]);

    React.useImperativeHandle(ref, () => ({
        editDialog: (item, index) => {
            setSelectedItem(item);
            setIndex(index);
            setOpen(true);
        }
    }));

    const handleOpen = () => {
        setSearchValue('');
        setItems([]);
        setOpen(true);
    }

    const handleClose = (event, reason) => {
        if (reason != 'backdropClick') {
            setOpen(false);
        }
    }

    const tag = (() => {
        return tags.find(t => t.id === tagId)
    })();

    const handleChange = e => {
        setSearchValue(e.target.value);
        if (searchValue.length < 2) {
            return;
        }
        MyListApi.getItems2(user, { name: e.target.value, tagId: tagId }, null, 0, 5)
            .then(data => {
                setItems(data.items);
            });
    }

    const handleClick = i => () => {
        setSelectedItem(i);
    }

    const handleSetLink = () => {
        if (!selectedItem) {
            return;
        }

        setOpen(false);
        onChange?.(selectedItem, index);
        setSelectedItem(null);
    }

    const handleClear = () => {
        dispatch(resetStatus());
        setSearchValue('');
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Link</DialogTitle>
                <DialogContent>
                    <b>{label}</b><RightIcon />{selectedItem ? selectedItem.name : ''}
                    <h1 style={{ textTransform: 'capitalize'}}>{tag?.name}</h1>
                    <OutlinedInput value={searchValue} onChange={handleChange} endAdornment={<ClearIcon onClick={handleClear} sx={{ cursor: 'pointer' }} />} />
                    <List sx={{ width: '100%' }}>
                        {items.map((i, ix) =>
                            <ListItemButton key={ix} onClick={handleClick(i)}>
                                <ListItemAvatar>
                                    <Avatar>
                                        <TagIcon name={tag.name} />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={i.name} />
                            </ListItemButton>
                        )}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='secondary' onClick={handleClose}>Cancel</Button>
                    <Button variant='contained' onClick={handleSetLink} disabled={!selectedItem}>Set Link</Button>
                </DialogActions>
            </Dialog>
            <Button endIcon={<AddLinkIcon />} onClick={handleOpen}>Add Link</Button>
        </div>
    );
});